import { api } from "../utils/AuthManager";

const GetClient = async (id) => {
  return api
    .get(`/api/client/${id}/`)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default GetClient;
